<div id="slider">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-3">
                CBSE Affiliation No.: 530251
            </div>

            <div class="col-6">
                <marquee behavior="scroll" direction="left" routerLink="/admission/registration-form"> Admission Open
                    For Nursery to XII For The Session(2026-27)</marquee>
            </div>
            <div class="col-3">
                <span class="float-right">School Code : 40235</span>
            </div>
        </div>

    </div>
</div>